import { NavigationItem } from '@cvx/nextpage';

export const APP_ROUTES = {
  DASHBOARD: 'dashboard',
  DISCOVER: 'discover',
  EVALUATION: 'evaluations',
  OPERATION_LOG: 'operations-log',
  ERROR: 'error',
  UNAUTHORIZED: 'unauthorized',
} as const;

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Dashboard',
    link: `/${APP_ROUTES.DASHBOARD}`,
  },
  {
    label: 'Discover',
    link: `/${APP_ROUTES.DISCOVER}`,
  },
  {
    label: 'Evaluation',
    link: `/${APP_ROUTES.EVALUATION}`,
  },
  {
    label: 'Operations Log',
    link: `/${APP_ROUTES.OPERATION_LOG}`,
  },
];
